import { render } from "./BaseCarousel.vue?vue&type=template&id=801e7826&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import "./BaseCarousel.vue?vue&type=style&index=0&id=801e7826&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801e7826"]])

export default __exports__